import { useEffect, useState } from "react";
import { ArrowRight } from "lucide-react";
import { HomeworkShell } from "./HomeworkShell";
import { hwApi, fmtDate } from "./hwApi";

function ResultsInner() {
  const [results, setResults] = useState(null);

  useEffect(() => {
    hwApi.get("/results").then(({ data }) => setResults(data.results)).catch(() => setResults([]));
  }, []);

  if (!results) return <div className="tp-wrap"><p className="tp-muted">Loading…</p></div>;

  return (
    <div className="tp-wrap" data-testid="hw-results">
      <div className="tp-eyebrow">MY RESULTS</div>
      <h1 className="tp-h2" style={{ fontSize: 30 }}>Evaluated homework</h1>
      {results.length === 0 && <p className="tp-muted" data-testid="hw-results-empty">No results yet — submit a homework and Pranjal Sir will evaluate it.</p>}
      {results.map((r) => (
        <div className="tp-panel" style={{ marginTop: 14 }} key={r.assignment_id} data-testid={`hw-result-${r.assignment_id}`}>
          <div className="admin-row">
            <b style={{ color: "#0b2545", flex: 1 }}>{r.title}</b>
            <b style={{ color: r.percentage >= 70 ? "#4ade80" : r.percentage >= 40 ? "#fbbf24" : "#ff9e9e", fontSize: 18 }}>{r.total}/{r.max_total} · {r.percentage}%</b>
          </div>
          <p className="tp-muted" style={{ margin: "6px 0 10px", fontSize: 13 }}>Submitted {fmtDate(r.submitted_at)} · Evaluated {fmtDate(r.evaluated_at)}</p>
          <a className="tp-btn small" href={`/homework/assignments/${r.assignment_id}`} data-testid={`hw-result-open-${r.assignment_id}`}>View report <ArrowRight size={14} /></a>
        </div>
      ))}
    </div>
  );
}

export default function HomeworkResults() {
  return <HomeworkShell><ResultsInner /></HomeworkShell>;
}
